import React, { useEffect } from 'react';
import { useChartContext } from '../components/chart.context';
import { getFitContent$ } from '@client/events';
import { IChartApi } from 'lightweight-charts';

export const fitContent = (chartRef: React.RefObject<IChartApi | null>) => {
  chartRef.current?.timeScale().fitContent();
};

export const useFitContent = () => {
  const { chartRef } = useChartContext();

  useEffect(() => {
    const subscription = getFitContent$().subscribe(() => {
      fitContent(chartRef);
    });

    return () => {
      subscription.unsubscribe();
    };
  }, []);
};
